(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var accentMap = {
    pink: 'var(--pss-pink)',
    orange: 'var(--pss-orange)',
    gold: 'var(--pss-gold)',
    teal: 'var(--pss-teal)',
    purple: 'var(--pss-purple)'
  };

  var popColors = ['#F8409F', '#F87830', '#F8D060', '#50E0D4', '#b58bd6'];

  function pad2(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function confettiPop(slide) {
    if (reducedMotion || !slide) return;

    var panel = slide.querySelector('.pss-hero-cine__copy-panel');
    if (!panel) return;

    var burst = document.createElement('div');
    burst.className = 'pss-hero-cine__confetti-burst';
    burst.setAttribute('aria-hidden', 'true');

    for (var i = 0; i < 14; i++) {
      var angle = (i / 14) * Math.PI * 2 + Math.random() * 0.4;
      var dist = 36 + Math.random() * 32;
      var particle = document.createElement('span');
      particle.className = 'pss-hero-cine__confetti-pop';
      particle.style.background = popColors[i % popColors.length];
      particle.style.setProperty('--pop-x', Math.round(Math.cos(angle) * dist) + 'px');
      particle.style.setProperty('--pop-y', Math.round(Math.sin(angle) * dist) + 'px');
      if (i % 3 === 0) {
        particle.style.borderRadius = '50%';
      }
      burst.appendChild(particle);
    }

    panel.appendChild(burst);
    window.setTimeout(function () {
      if (burst.parentNode) burst.parentNode.removeChild(burst);
    }, 850);
  }

  function initCarousel(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
    var slideCount = slides.length;

    if (slideCount <= 1) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-dot]'));
    var filmThumbs = Array.prototype.slice.call(root.querySelectorAll('[data-hero-film-thumb]'));
    var prevBtn = root.querySelector('[data-carousel-prev]');
    var nextBtn = root.querySelector('[data-carousel-next]');
    var stage = root.matches('[data-hero-stage]') ? root : root.querySelector('[data-hero-stage]');
    var counter = root.querySelector('[data-hero-counter]');
    var autoplay = root.dataset.autoplay === 'true' && !reducedMotion;
    var interval = parseInt(root.dataset.interval, 10) || 3000;
    var current = 0;
    var timer = null;
    var pointerStartX = 0;
    var pointerActive = false;
    var isInitial = true;

    root.style.setProperty('--slide-duration', interval + 'ms');

    function applyAccent(slide) {
      if (!slide || !stage) return;
      var accent = slide.dataset.accent || 'pink';
      var accentVar = accentMap[accent] || accentMap.pink;
      stage.style.setProperty('--slide-accent', accentVar);
    }

    function updateChrome() {
      if (counter) {
        counter.textContent = pad2(current + 1) + ' / ' + pad2(slideCount);
      }

      filmThumbs.forEach(function (thumb) {
        var idx = parseInt(thumb.dataset.index, 10);
        var active = idx === current;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function goTo(index) {
      var nextIndex = (index + slideCount) % slideCount;
      if (nextIndex === current && slides[current].classList.contains('is-active')) {
        return;
      }

      var changed = nextIndex !== current;
      current = nextIndex;

      slides.forEach(function (slide, i) {
        var active = i === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === current);
        dot.setAttribute('aria-selected', i === current ? 'true' : 'false');
      });

      applyAccent(slides[current]);
      updateChrome();

      if (changed && !isInitial) {
        confettiPop(slides[current]);
      }
      isInitial = false;
    }

    function next() {
      goTo(current + 1);
    }

    function prev() {
      goTo(current - 1);
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      updateChrome();
      if (!autoplay) return;
      timer = setInterval(next, interval);
    }

    slides.forEach(function (slide, i) {
      slide.setAttribute('aria-hidden', i === 0 ? 'false' : 'true');
    });

    applyAccent(slides[0]);
    updateChrome();

    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); startAutoplay(); });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
        startAutoplay();
      });
    });

    filmThumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = parseInt(thumb.dataset.index, 10);
        if (!isNaN(idx)) {
          goTo(idx);
          startAutoplay();
        }
      });
    });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        prev();
        startAutoplay();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        next();
        startAutoplay();
      }
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    });

    root.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      pointerActive = true;
      pointerStartX = e.clientX;
    });

    root.addEventListener('pointerup', function (e) {
      if (!pointerActive) return;
      pointerActive = false;
      var delta = e.clientX - pointerStartX;
      if (Math.abs(delta) < 40) return;
      if (delta < 0) next();
      else prev();
      startAutoplay();
    });

    root.addEventListener('pointercancel', function () {
      pointerActive = false;
    });

    startAutoplay();
  }

  function init() {
    document.querySelectorAll('[data-pss-hero-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
